module.exports = __webpack_public_path__ + "img/apoio-horus.a0579756.png";